"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var custom_checkbox_icon_module_scss_1 = __importDefault(require("./custom-checkbox-icon.module.scss"));

var CheckBox_1 = __importDefault(require("@material-ui/icons/CheckBox"));

var CheckBoxOutlineBlank_1 = __importDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var CustomCheckBoxIcon = function CustomCheckBoxIcon(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? true : _ref$checked;
  return checked ? react_1.default.createElement(CheckBox_1.default, {
    fontSize: "large",
    className: custom_checkbox_icon_module_scss_1.default.icon
  }) : react_1.default.createElement(CheckBoxOutlineBlank_1.default, {
    fontSize: "large",
    className: custom_checkbox_icon_module_scss_1.default.icon
  });
};

exports.default = CustomCheckBoxIcon;